import { useGenericMutation } from '@hooks/use-generic-mutation';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { AuthTokenResponse } from './type';

const signOut = async (refreshToken: string) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/log-out`;

  return request({ url, method: RequestMethod.POST, body: { refreshToken }, withCredentials: true });
};

export const useSignout = () => {
  return useGenericMutation<AuthTokenResponse, RequestError, { refreshToken: string }>(
    [QUERY_KEYS.signout],
    async ({ refreshToken }: { refreshToken: string }) => signOut(refreshToken)
  );
};
